module.exports = __webpack_public_path__ + "static/media/39.3207a594.png";